import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITradeBatchRequest } from '../interface/batch/trade/ITradeBatchRequest';
import { IOriginationBatchRequest } from '../interface/batch/origination/IOriginationBatchRequest';
import { IFeePaymentBatchRequest } from '../interface/batch/FeePayment/IFeePaymentBatchRequest';
import { IBatchEntuba } from '../interface/entuba/IBatchEntuba';
import { IExpenseBatchRequest } from '../interface/batch/expense/IExpenseBatchRequest';
import { IExpenseBatch } from '../interface/batch/expense/IExpenseBatch';
import { IReconcileSettlementBatchRequest } from '../interface/batch/ReconcileSettlement/IReconcileSettlementBatchRequest';
import { IReconcileSettlementBatchItem } from '../interface/batch/ReconcileSettlement/IReconcileSettlementBatchItem';
import { IToggleAccrualBatchItem } from '../interface/batch/ToggleAccrual/IToggleAccrualBatchItem';
import { IToggleAccrualBatchRequest } from '../interface/batch/ToggleAccrual/IToggleAccrualBatchRequest';

enum BatchServiceEnum {
  trade = "/trade",
  origination = "/origination",
  expense = "/expense",
  feePayment = "/fee-payment",
  reconcileSettlement = "/reconcile-settlement",
  toggleAccrual = "/toggle-accrual"
}

export class BatchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/batch");
  }

  public getAllTradeBatchs = async () => await this.GET(BatchServiceEnum.trade);
  public getTradeBatchDetail = async (id: number) => await this.GET(`${BatchServiceEnum.trade}/${id}`);
  public startTradeEntuba = async (data: ITradeBatchRequest) => await this.POST(BatchServiceEnum.trade, data);

  public getAllOriginationBatchs = async (): Promise<IBatchEntuba[]> => await this.GET(BatchServiceEnum.origination);
  public getOriginationBatchDetail = async (entubaId: number) => await this.GET(`${BatchServiceEnum.origination}/${entubaId}`);
  public startOriginationEntuba = async (data: IOriginationBatchRequest): Promise<number> => await this.POST(BatchServiceEnum.origination, data);

  public getAllExpenseBatchs = async (): Promise<IExpenseBatch[]> => await this.GET(BatchServiceEnum.expense);
  public getExpenseBatchDetail = async (entubaId: number) => await this.GET(`${BatchServiceEnum.expense}/${entubaId}`);
  public startExpenseEntuba = async (data: IExpenseBatchRequest): Promise<number> => await this.POST(BatchServiceEnum.expense, data);

  public getAllFeePaymentBatchs = async () => await this.GET(BatchServiceEnum.feePayment);
  public getFeePaymentBatchDetail = async (id: number) => await this.GET(`${BatchServiceEnum.feePayment}/${id}`);
  public startFeePaymentEntuba = async (data: IFeePaymentBatchRequest) => await this.POST(BatchServiceEnum.feePayment, data);

  public getAllReconcileSettlementBatchs = async (): Promise<IBatchEntuba[]> => await this.GET(BatchServiceEnum.reconcileSettlement);
  public getReconcileSettlementBatchDetail = async (id: number): Promise<IReconcileSettlementBatchItem[]> => await this.GET(`${BatchServiceEnum.reconcileSettlement}/${id}`);
  public startReconcileSettlementEntuba = async (data: IReconcileSettlementBatchRequest) => await this.POST(BatchServiceEnum.reconcileSettlement, data);

  public getAllToggleAccrualBatchs = async (): Promise<IBatchEntuba[]> => await this.GET(BatchServiceEnum.toggleAccrual);
  public getToggleAccrualBatchDetail = async (id: number): Promise<IToggleAccrualBatchItem[]> => await this.GET(`${BatchServiceEnum.toggleAccrual}/${id}`);
  public startToggleAccrualEntuba = async (data: IToggleAccrualBatchRequest) => await this.POST(BatchServiceEnum.toggleAccrual, data);
}
